module.exports = require('./bundle').parser()
